import { render, staticRenderFns } from "./PageRedirect.vue?vue&type=template&id=0db44c12&"
import script from "./PageRedirect.vue?vue&type=script&lang=js&"
export * from "./PageRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports